import {memo} from 'react';

export const ObjectCreate = memo(() => {
  return (
    <svg
      width="24"
      height="28"
      viewBox="0 0 24 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.333374"
        y="2.99988"
        width="20.2222"
        height="24.1111"
        rx="6"
        fill="#EFF4FF"
      />
      <path
        d="M8.17213 10.2333V15.2852L4.88892 14.5963L9.11019 17.5814L7.23407 19.4185L11.9244 17.1222L12.6279 19.8778L12.9659 15.2852L15.9111 15.7444L11.4553 12.9889L13.566 10.6926L9.11019 12.9889L8.17213 10.2333Z"
        fill="#4371CB"
        stroke="#4371CB"
      />
      <path
        d="M20.7916 7.15247H21.2916V6.65247V5.68025V5.18025H20.7916H18.375V2.76358V2.26358H17.875H16.9028H16.4028V2.76358V5.18025H13.9861H13.4861V5.68025V6.65247V7.15247H13.9861H16.4028V9.56914V10.0691H16.9028H17.875H18.375V9.56914V7.15247H20.7916Z"
        fill="#3869C7"
        stroke="white"
      />
    </svg>
  );
});
ObjectCreate.displayName = 'ObjectCreate';
